document.addEventListener('DOMContentLoaded', () => {
    const hasSwiper = (typeof Swiper !== 'undefined');

    const blocks = document.querySelectorAll('.slider-ingredients-block');
    blocks.forEach((block) => {
        let mySwiper = null;
        let originalSlides = [];
        const swiperContainer = block.querySelector('.ingredients-swiper');

        if (hasSwiper && swiperContainer) {
            mySwiper = new Swiper(swiperContainer, {
                slidesPerView: "auto",
                spaceBetween: 24,
                loop: true,
                navigation: {
                    nextEl: block.querySelector('.swiper-button-next'),
                    prevEl: block.querySelector('.swiper-button-prev'),
                },
            });
            originalSlides = Array.from(mySwiper.slides).map(sl => sl.cloneNode(true));
        }

        const mobileWrap = block.querySelector('.cards-wrap.d-flex.flex-nowrap.d-md-none');
        let mobileCards = [];
        if (mobileWrap) {
            mobileCards = Array.from(
                mobileWrap.querySelectorAll('.mobile-ingredient-card[data-ingredient-id]')
            );
        }

        let currentActiveStep = null;
        const steps = block.querySelectorAll('.slider-ingredients-block__step[data-ingredient-ids]');
        steps.forEach(step => {
            step.addEventListener('click', () => {
                if (currentActiveStep === step) {
                    step.classList.remove('active');
                    currentActiveStep = null;

                    if (mySwiper) {
                        mySwiper.removeAllSlides();
                        originalSlides.forEach(sl => {
                            mySwiper.appendSlide(sl.cloneNode(true));
                        });
                        mySwiper.update();
                    }

                    if (mobileCards.length > 0) {
                        mobileCards.forEach(card => card.classList.remove('d-none'));
                    }
                    return;
                }

                if (currentActiveStep) {
                    currentActiveStep.classList.remove('active');
                }
                currentActiveStep = step;
                step.classList.add('active');

                const idsRaw = step.getAttribute('data-ingredient-ids') || '';
                const ids = idsRaw.split(',').map(x => x.trim()).filter(Boolean);

                if (mySwiper) {
                    mySwiper.removeAllSlides();
                    originalSlides.forEach(sl => {
                        const termId = sl.getAttribute('data-ingredient-id');
                        if (termId && ids.includes(termId)) {
                            mySwiper.appendSlide(sl.cloneNode(true));
                        }
                    });
                    mySwiper.update();
                }

                if (mobileCards.length > 0) {
                    mobileCards.forEach(card => {
                        const termId = card.getAttribute('data-ingredient-id');
                        if (termId && ids.includes(termId)) {
                            card.classList.remove('d-none');
                        } else {
                            card.classList.add('d-none');
                        }
                    });
                }
            });
        });
    });
});